import { render } from "./CustomerInsightsFilters.vue?vue&type=template&id=960dfb6e&scoped=true"
import script from "./CustomerInsightsFilters.vue?vue&type=script&lang=js"
export * from "./CustomerInsightsFilters.vue?vue&type=script&lang=js"

import "./CustomerInsightsFilters.vue?vue&type=style&index=0&id=960dfb6e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-960dfb6e"]])

export default __exports__